export default function WhyChooseSection() {
  const reasons = [
    {
      icon: 'ri-user-star-line',
      title: 'Experienced Legal Team',
      description: 'Over 20 years of dedicated workers compensation law experience in Ohio.',
    },
    {
      icon: 'ri-map-pin-user-line',
      title: 'Local Northeast Ohio Focus',
      description: 'Deep knowledge of local courts, judges, and Ohio workers compensation system.',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Personalized Attention',
      description: 'Direct access to your attorney. We treat every client like family.',
    },
    {
      icon: 'ri-trophy-line',
      title: 'Proven Track Record',
      description: 'Millions recovered for injured workers throughout Northeast Ohio.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'No Upfront Costs',
      description: 'Contingency fee basis. You pay nothing unless we win your case.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Our Firm
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Dedicated advocacy for injured workers with a proven commitment to results
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="relative mb-6 last:mb-0"
              style={{
                transform: `rotate(${(index - 2) * 1.5}deg)`,
                zIndex: reasons.length - index,
              }}
            >
              <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 hover:scale-105">
                <div className="flex items-start space-x-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
                    <i className={`${reason.icon} text-3xl text-teal-600`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{reason.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">{reason.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}